import { render, staticRenderFns } from "./updateLabel.vue?vue&type=template&id=016989ac&scoped=true&"
import script from "./updateLabel.vue?vue&type=script&lang=js&"
export * from "./updateLabel.vue?vue&type=script&lang=js&"
import style0 from "./updateLabel.vue?vue&type=style&index=0&id=016989ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016989ac",
  null
  
)

export default component.exports